import { render, staticRenderFns } from "./KnowledgePage.vue?vue&type=template&id=473ad76e&scoped=true"
import script from "./KnowledgePage.vue?vue&type=script&lang=js"
export * from "./KnowledgePage.vue?vue&type=script&lang=js"
import style0 from "./KnowledgePage.vue?vue&type=style&index=0&id=473ad76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ad76e",
  null
  
)

export default component.exports